import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Grid } from "@mui/material";
import i18n from "../../../../i18n";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CloseIcon } from "../../../../styles/img/svg/CloseIcon";
import { BackIcon } from "../../../../styles/img/svg/BackIcon";
import {
  commonConstants,
  onboardingConstants,
  TRANSLATION_CONST,
} from "../../../../_redux/_constants";
import { ProgressBar } from "../../../_uiComponents/Onboarding/ProgressBar";
import {
  backOfficeValidationRequest,
  onboardingClearFormData,
  onboardingClearFormResponseData,
  removeFormDataFeilds,
} from "../../../../_redux/_actions/onboarding.actions";
import VerificationProgressImage from "../../../../styles/img/onboard/verify-progress.png";
import { UiTextIconButton } from "../../../_uiComponents/common/UiButton";
import { DisableReloadIcon } from "../../../../styles/img/svg/DisableReloadIcon";
import { ReloadIconBlue } from "../../../../styles/img/svg/ReloadIconBlue";
import { clearCommonErrors } from "../../../../_redux/_actions";
import { RequestRejectedPopup } from "../popups/RequestRejectedPopup";
import { ApprovalPendingPopup } from "../popups/ApprovalPendingPopup";
import OnItImg from "../../../../styles/img/onboard/Onit-Img.png"

export const VerificationInProgressScreen = (props) => {
  const dispatch = useDispatch();
  const naviagate = useNavigate();
  const { ownFormData: ownFormData, verificationData: verificationData } =
    useSelector((state) => state.onboarding);
  const { t, i18n } = useTranslation();

  const [countDown, setCountDown] = useState(1);
  const [isManualRetry, setIsManualRetry] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showPendingPopup, setShowPendingPopup] = useState(false);

  const goBack = () => {
    dispatch(onboardingClearFormResponseData());
    props?.changeFlowStep(onboardingConstants.SELECT_VERIFICATION_OPTION_STEP);
  };

  const verifyFunc = () => {
    dispatch(backOfficeValidationRequest({ locale: i18n.language }));
  };

  const goToLogin = () => {
    dispatch(onboardingClearFormResponseData());
    dispatch(onboardingClearFormData());
    dispatch(clearCommonErrors());
    naviagate("/");
  };

  const openClosePendingPopup = (param) => {
    setShowPendingPopup(param);
  };

  useEffect(() => {
    if (
      countDown >= process.env.ONBOARDING_VERIFICATION_ATEMPTS &&
      !isManualRetry
    ) {
      setIsManualRetry(true);
      return;
    }

    if (
      !verificationData?.isSubProfileActivationProcessCompleted &&
      !isManualRetry
    ) {
      return;
    }

    const isPending =
      verificationData?.isSubProfileActivationProcessCompleted ==
        commonConstants.NO_OPTION_TYPE &&
      verificationData?.customerRegistrationValidationStatus ===
        onboardingConstants.ONBOARDING_FLOW_PENDING;

    const isDeclined =
      verificationData?.isSubProfileActivationProcessCompleted ===
        commonConstants.NO_OPTION_TYPE &&
      verificationData?.customerRegistrationValidationStatus ===
        onboardingConstants.ONBOARDING_FLOW_DECLINED;

    const isAccepted =
      verificationData?.isSubProfileActivationProcessCompleted ===
        commonConstants.YES_OPTION_TYPE &&
      verificationData?.customerRegistrationValidationStatus ===
        onboardingConstants.ONBOARDING_FLOW_ACCEPTED;

    if (isAccepted) {
      dispatch(removeFormDataFeilds(["username"]));
      props?.changeFlowStep(onboardingConstants.ONBOARDING_USERNAME_STEP);
      return;
    }

    if (isDeclined) {
      setShowErrorPopup(true);
      return;
    }

    if (isPending && !isManualRetry) {
      const timeout = setTimeout(() => {
        verifyFunc();
        setCountDown((prev) => prev + 1);
      }, process.env.ONBOARDING_VERIFICATION_DELAY_MILISECONDS);
      return () => clearTimeout(timeout);
    }

    if (isPending && isManualRetry) {
      openClosePendingPopup(true);
    }
  }, [verificationData]);

  useEffect(() => {
    verifyFunc();
  }, []);

  return (
    <>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div
            className="df-user-profile__close-icon"
            onClick={props?.closeBtn}
          >
            <CloseIcon />
          </div>

          <div className="df-user-profile__back-icon df-bc-w-progress">
            <ProgressBar
              noOfActive={4}
              total={
                ownFormData?.registrationType ==
                onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT
                  ? 7
                  : 6
              }
            />

            <BackIcon onClick={goBack} />
          </div>

          <div className="df-user-profile__body df-pw-tab">
            <Grid container className="df-align-center">
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }} className="df-pr-2">
                <img
                  src={OnItImg}
                  className="df-verify-progress-img"
                />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-center df-pl-2"
              >
                <div className="df-onboard-radio df-onboard-nic-wr df-verify-progress">
                  <h4>{t("We're On It!")}</h4>
                  <p>
                    {t(
                      "Thank you for your patience as we verify and approve your account",
                    )}
                  </p>

                  <div
                    className={`d-block df-verify-progress__btn df-verify-link-progress${
                      i18n.language === TRANSLATION_CONST?.SINHALA.lan
                        ? "df-verification-progress-si"
                        : i18n.language === TRANSLATION_CONST?.TAMIL.lan
                          ? "df-verification-progress-ti"
                          : ""
                    } `}
                  >
                    {isManualRetry && (
                      <UiTextIconButton
                        onClick={verifyFunc}
                        icon={
                          !isManualRetry ? (
                            <DisableReloadIcon />
                          ) : (
                            <ReloadIconBlue />
                          )
                        }
                        name={t("Tap here to update status")}
                        className="df-primary-underlined-text-icon-btn"
                        beforeIcon
                        disabled={false}
                        loading={false}
                      />
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <RequestRejectedPopup isOpen={showErrorPopup} handleClose={goToLogin} />

      <ApprovalPendingPopup
        isOpen={showPendingPopup}
        closeModal={() => {
          openClosePendingPopup(false);
        }}
      />
    </>
  );
};
